export default "__VITE_ASSET__65598a73__"